import { render } from "./PopMonitor.vue?vue&type=template&id=efe1a052&scoped=true"
import script from "./PopMonitor.vue?vue&type=script&lang=js"
export * from "./PopMonitor.vue?vue&type=script&lang=js"

import "./PopMonitor.vue?vue&type=style&index=0&id=efe1a052&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe1a052"]])

export default __exports__